import * as React from "react";
import "./tab3.scss";
import SingleSelectDropzone from "../../../../../../../../../ui/dropzone/singleselect/singleSelectDropzone";

const Tab3 = () => {
    return (
        <div className="Tab3">
            <div className="row">
                <div className="col-lg-6 col-md-6 col-12 mb-3">
                    <h6 className="pt-3 pb-1">لینک سایت شما</h6>
                    <input type="text" name="" id="" className="Campaign-Input"
                           placeholder="مثال: کمپین روز مادر"/>
                </div>
                <div className="col-lg-6 col-md-6 col-12"></div>
                <div className="col-lg-6 col-md-6 col-12 mb-3">
                    <h6 className="pt-1 pb-1">منشن</h6>
                    <input type="text" name="" id="" className="Campaign-Input"
                           placeholder="مثال: کمپین روز مادر"/>
                </div>
                <div className="col-lg-6 col-md-6 col-12 mb-3">
                    <h6 className="pt-1 pb-1">تگ روی عکس</h6>
                    <input type="text" name="" id="" className="Campaign-Input"
                           placeholder="مثال: کمپین روز مادر"/>
                </div>
                <div className="col-lg-6 col-md-6 col-12 mb-3">
                    <h6 className="pt-1 pb-1">نبایدها</h6>
                    <textarea name="" id="" className="Campaign-Input" placeholder="بنویسید ..." cols={10}
                              rows={4}></textarea>
                </div>
                <div className="col-lg-6 col-md-6 col-12 mb-3">
                    <h6 className="pt-1 pb-1">بایدها</h6>
                    <textarea name="" id="" className="Campaign-Input" placeholder="بنویسید ..." cols={10}
                              rows={4}></textarea>
                </div>
                <div className="col-lg-6 col-md-6 col-12 mb-3">
                    <h6 className="pt-1 pb-1">پیشنهاد استفاده از محصولات</h6>
                    <textarea name="" id="" className="Campaign-Input" placeholder="بنویسید ..." cols={10}
                              rows={4}></textarea>
                </div>
                <div className="col-lg-6 col-md-6 col-12 mb-3">
                    <h6 className="pt-1 pb-1">سناریو و متن محتوا</h6>
                    <textarea name="" id="" className="Campaign-Input" placeholder="بنویسید ..." cols={10}
                              rows={4}></textarea>
                </div>
                <div className="col-lg-6 col-md-6 col-12 mb-3 d-flex align-items-end justify-content-start">
                    <SingleSelectDropzone title={"فایل پیشنهادی"}/>
                </div>
                <div className="col-lg-6 col-md-6 col-12 mb-3">
                    <h6 className="pt-1 pb-1">توضیحات فایل پیشنهادی</h6>
                    <textarea name="" id="" className="Campaign-Input" placeholder="بنویسید ..." cols={10}
                              rows={4}></textarea>
                </div>
            </div>
        </div>
    );
}

export default Tab3;